import moment from "moment";

export default {
	/**
	 * format value as per unit
	 * @method formatValue
	 * @param {Number} value to covert/abbreviate
	 * @param {String} unit 'percentage' | 'bytes' | 'time' | 'default'
	 */
	formatValue(value, unit) {
		if (unit === "percentage") {
			return `${this.abbreviateNumber(value)} %`;
		} else if (unit === "bytes") {
			return this.abbreviateBytes(value, 0);
		} else if (unit === "time") {
			return this.abbreviateTime(value);
		} else {
			return this.abbreviateNumber(value, 1);
		}
	},

	/**
	 * Formatting number
	 * @method abbreviateNumber
	 * @param {Number} num to covert/abbreviate
	 * @param {Number} fixed how many digits to display after decimal point
	 */
	abbreviateNumber(num, fixed) {
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return "0";
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;

		const b = num.toPrecision(2).split("e"),
			k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
			c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
			d = c < 0 ? c : Math.abs(c),
			e = d + ["", " K", " M", " B", " T"][k];
		return e;
	},

	/**
	 * Formatting Bytes
	 * @method abbreviateBytes
	 * @param {Number} bytes to abbreviate
	 * @param {Number} decimals how many digits to display after decimal point
	 */
	abbreviateBytes(bytes, decimals = 2) {
		if (bytes === 0) {
			return "0 Bytes";
		}

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
	},

	/**
	 * Formatting Time
	 * @method abbreviateTime
	 * @param {Number} milliseconds to abbreviate
	 */
	abbreviateTime(milliseconds) {
		const duration = moment.duration(milliseconds);
		if (duration.days() > 0) {
			return `${duration.days()} days`;
		} else if (duration.hours() > 0) {
			return `${duration.hours()} hrs`;
		} else if (duration.minutes() > 0) {
			return `${duration.minutes()} min`;
		} else if (duration.seconds() > 0) {
			return `${duration.seconds()} sec`;
		} else if (duration.milliseconds() > 0) {
			return `${duration.milliseconds()} ms`;
		} else if (milliseconds === 0) {
			return "0 ms";
		}
	}
};
